import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  withRouter,
} from "react-router-dom";
import Signup from "./components/Signup";
import Login from "./components/Login";
import ResetPassword from "./components/ResetPassword";
import ChangePassword from "./components/ChangePassword";
import Dashboard from "./components/Dashboard";
import Invoices from "./components/Invoices";
import Billings from "./components/Billings";
import Customers from "./components/Customers";
import Leftnav from "./components/Leftnav";
import Topnav from "./components/Topnav";
import PrivateRoute from "./PrivateRoute";
import Plans from "./components/Plans";
import Checkout from "./components/Checkout";

import { toast } from "react-toastify";
import VerifyEmail from "./components/VerifyEmail";
import { useDispatch, useSelector } from "react-redux";
import { getCookie, getAccessToken } from "./helpers/genericHelpers";
import { validateToken } from "./redux/actions/authAction";
import SwitchPlan from "./components/SwitchPlan";
import ScrollToTop from "./helpers/ScrollToTop";
toast.configure({
  position: toast.POSITION.TOP_RIGHT,
});

const PrivateComponentWrapper = () => {
  const adminContentArea = useRef();
  return (
    <>
      <div className="admin-wrapper">
        <div className="container-fluid admin-wrapper-fluid">
          <div className="row admin-wrapper-row">
            <Leftnav />
            <div className="col admin-wrapper-rightsection">
              <Topnav />
              <div className="admin-content-area" ref={adminContentArea}>
                <ScrollToTop adminContentArea={adminContentArea} />
                <Switch>
                  <Route path="/" exact component={Dashboard} />
                  <Route path="/invoices" component={Invoices} />
                  <Route path="/billings" component={Billings} />
                  <Route path="/customers" component={Customers} />
                  <Route path="/plans" component={Plans} />
                  <Route path="/checkout" component={Checkout} />
                  <Route path="/switch-plan" component={SwitchPlan} />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function App(props) {
  const dispatch = useDispatch();
  const { isAuthenticated, isLoginStarted } = useSelector(
    (state) => state.authData
  );

  useEffect(() => {
    const accessToken = getAccessToken();
    if (accessToken) {
      if (!isAuthenticated) {
        dispatch(validateToken());
      }
    } 
  }, [isAuthenticated]);

  return (
    <Router>
      <Switch>
        <Route path="/login" exact component={Login} />
        <Route path="/signup" component={Signup} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/change-password" component={ChangePassword} />
        <Route path="/verify-email" component={VerifyEmail} />
        <PrivateRoute path="/" component={PrivateComponentWrapper} />
      </Switch>
    </Router>
  );
}

export default withRouter(App);
